export const ticketProcessTypes = {
  STANDARD_SHIPPING: 0,
  WILL_CALL: 1,
  PRINT_AT_HOME: 2,
  PRINT_IMMEDIATELY: 3,
  FLASH_SEATS: 4,
  EXTERNAL_PDF: 5,
  FLASH_SEATS_HOLD: 6,
  EXTERNAL_LISTED_FLASH_SEATS: 7,
  EXTERNAL_LISTED_STANDARD_SHIPPING: 8,
  EXTERNAL_LISTED_WILL_CALL: 9,
  EXTERNAL_LISTED_PRINT_AT_HOME: 10,
  EXTERNAL_LISTED_PRINT_IMMEDIATELY: 11,
  EXTERNAL_LISTED_PDF: 12,
};



// WEBPACK FOOTER //
// ./src/common/constants/ticketProcessTypes.js